export default "__VITE_ASSET__4a61cb3e__"